"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _react = require("react");
var useLongPress = function useLongPress(onLongPress, onClick) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 500;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isPressing = _useState2[0],
    setIsPressing = _useState2[1];
  var timeoutRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (isPressing) {
      timeoutRef.current = setTimeout(onLongPress, duration);
    } else {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    }
    return function () {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [isPressing]);
  var handleMouseDown = function handleMouseDown() {
    setIsPressing(true);
  };
  var handleMouseUp = function handleMouseUp(event) {
    setIsPressing(false);
    if (onClick && timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      onClick(event);
    }
  };
  return {
    onMouseDown: handleMouseDown,
    onMouseUp: handleMouseUp,
    onTouchStart: handleMouseDown,
    onTouchEnd: handleMouseUp
  };
};
var _default = useLongPress;
exports.default = _default;